import React, {useState} from 'react';
import DatePicker from 'react-datepicker';

import "react-datepicker/dist/react-datepicker.css";

import { reportService } from '../../Services';

import {ReactComponent as Loading} from '../../images/icons/General/loading-01.svg';

const AttendanceBadge = ({ pct, label }) => {
    const color = pct >= 70 ? '#22c55e' : pct >= 40 ? '#f59e0b' : '#ef4444';
    return (
        <span style={{ color, fontWeight: 600, whiteSpace: 'nowrap' }}>
            {label && <span style={{ fontWeight: 400, color: '#6b7280', marginRight: 4 }}>{label}:</span>}
            {pct.toFixed(0)}%
        </span>
    );
};

export const Attendance = () => {
    const getLastSaturday = () => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() - ((d.getDay() + 1) % 7));
        return d;
    };

    const [report, setReport] = useState([]);
    const defaultEnd = getLastSaturday();
    const defaultStart = new Date(defaultEnd.getFullYear(), defaultEnd.getMonth(), 1);

    const [startDate, setStartDate] = useState(defaultStart);
    const [endDate, setEndDate] = useState(defaultEnd);
    const [loading, setLoading] = useState(false);


    const handleReport = async () => {
        if (startDate && endDate) {
            setLoading(true);
            const res = await reportService.attendanceReport({
                startDate: startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate(),
                endDate: endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate()
            });

            if (res)
                setReport(res.report);

            setLoading(false);
        }
    }

    return (
        <>
            <h1 id="report-title">Divers' Attendance Report</h1>
            <div id="report">
                <div className="bordered-content mt-32">
                    <div className="header">
                        <div className="select-year sentence">
                            Report of Divers' attendance from <DatePicker name="startDate" selected={startDate} onChange={setStartDate} placeholderText="Select date" className="required" isClearable /><br className="mobile" />
                            to <DatePicker name="endDate" selected={endDate} onChange={setEndDate} placeholderText="Select date" className="required" isClearable />
                        </div>
                            <button className="primary" type="button" onClick={handleReport}>{loading ? <Loading className="btn-loader"alt="loader" /> : ''}Generate report</button>
                    </div>
                </div>
                {(!loading && report?.length > 0) && <div className="attendance-report">
                        {report.map(team => (
                            <div key={team.TeamID} className="bordered-content">
                                <div className="header">
                                    <div>
                                        <strong>{team.TeamName}: </strong>
                                        {team.TeamDescription && <span>{team.TeamDescription}</span>}
                                    </div>
                                </div>
                                <table className="table">
                                    <tbody>
                                        {team.members.map(m => (
                                            <tr key={m.UserID}>
                                                <td>
                                                    {m.FirstName} {m.LastName}
                                                    {m.TeamLeader === 1 && <span className="badge">Leader</span>}
                                                </td>
                                                <td className="right" style={{ width:'50px'}}>
                                                    <AttendanceBadge pct={parseFloat(m.AttendancePct)} />
                                                </td>
                                                <td className="right" style={{ width:'150px'}}>
                                                    {m.WeeksWithDives} of {m.TotalWeeks} weeks
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </div>
                }
            </div> 
        </>
    );
};

export default Attendance;